export default function hasDebugCookie() {
  return /^(.*;)?\s*_debug\s*=/.test(document.cookie);
}
